import { useMutation } from '@tanstack/react-query';
import { updateUserGoalSortMode } from 'shared/services/backend-api';
import { GoalSortingMode } from 'shared/types/sorting-mode';

export const useUpdateGoalSortModeMutation = () =>
  useMutation({
    mutationFn: async (sortMode: GoalSortingMode) =>
      updateUserGoalSortMode(sortMode),
  });
